import { fetch } from './api-wrapper';

// Promise wrappers around the callback-style api-wrapper for the per-client
// SCIM admin endpoints (xpens-api XPEN-2627). Each resolves with the response
// body and rejects with the axios error so callers can use async/await.
const call = (url, method, params = {}) =>
  new Promise((resolve, reject) => {
    fetch(
      url,
      method,
      params,
      (res) => resolve(res.data),
      (err) => reject(err),
    );
  });

export const getScimConfig = (clientId) =>
  call(`/clients/${clientId}/scim/config`, 'GET', {});

// Generates or rotates the bearer token. The raw token is in the response and
// is shown to the admin exactly once — it is never returned again.
export const generateScimToken = (clientId) =>
  call(`/clients/${clientId}/scim/token`, 'POST', {});

export const revokeScimToken = (clientId) =>
  call(`/clients/${clientId}/scim/token`, 'DELETE', {});

export const setScimActivation = (clientId, enabled) =>
  call(`/clients/${clientId}/scim/activation`, 'PUT', { enabled });

export const getScimAuditLogs = (clientId, params = {}) =>
  call(`/clients/${clientId}/audit-logs`, 'GET', params);
